function Illustration() {
  return (
    <svg width="70" height="54" viewBox="0 0 70 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="35" cy="46.3168" rx="34.25" ry="7.17619" fill="#F4EFE9" />
      <g filter="url(#filter0_b_8001_10851)">
        <path
          d="M58.8119 23.3565V46.3203H55.4102H19.1881C14.7698 46.3203 11.1881 42.7386 11.1881 38.3203V23.3565H58.8119Z"
          fill="white"
          fillOpacity="0.5"
        />
      </g>
      <path
        d="M21.5034 11.1973C22.2634 10.3015 23.3788 9.78516 24.5535 9.78516H45.4466C46.6213 9.78516 47.7366 10.3015 48.4966 11.1973L58.8119 23.3547H49.5698C47.9564 23.3547 46.501 24.3239 45.879 25.8126L45.3162 27.1596C44.6942 28.6483 43.2388 29.6175 41.6254 29.6175H28.3746C26.7612 29.6175 25.3058 28.6483 24.6838 27.1596L24.121 25.8126C23.499 24.3239 22.0436 23.3547 20.4302 23.3547H11.1881L21.5034 11.1973Z"
        fill="#F4EFE9"
        stroke="#B4985A"
        strokeLinejoin="round"
      />
      <path
        d="M58.8119 46.3203V23.3565M11.1881 23.3565V38.3203C11.1881 42.7386 14.7698 46.3203 19.1881 46.3203H55.4102"
        stroke="#B4985A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="mask0_8001_10851" maskUnits="userSpaceOnUse" x="11" y="0" width="48" height="30">
        <path
          d="M11.1887 4C11.1887 1.79086 12.9796 0 15.1887 0H54.8125C57.0217 0 58.8125 1.79086 58.8125 4V23.029H49.4613C47.9034 23.029 46.4873 23.9335 45.8322 25.3468L45.0779 26.9741C44.4227 28.3875 43.0066 29.2919 41.4488 29.2919H28.4709C26.8881 29.2919 25.4541 28.3585 24.8133 26.9112L24.1487 25.4098C23.5079 23.9624 22.0739 23.029 20.4911 23.029H11.1887V4Z"
          fill="#FFECE1"
        />
      </mask>
      <g mask="url(#mask0_8001_10851)">
        <rect
          x="21.4744"
          y="2.45703"
          width="27.7048"
          height="27.0524"
          rx="2.5"
          fill="#F4EFE9"
          stroke="#B4985A"
          strokeDasharray="2 2"
        />
        <rect
          x="18.8649"
          y="5.06641"
          width="32.9238"
          height="25.0952"
          rx="2.5"
          fill="#F4EFE9"
          stroke="#B4985A"
          strokeDasharray="2 2"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_8001_10851"
          x="7.18811"
          y="19.3555"
          width="55.6238"
          height="30.9648"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_8001_10851" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_8001_10851" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default Illustration;
